import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CurrencyConversionRatePropTypes } from '../../shared/propTypes/currencyConversionRate';
import { FaPencilAlt as PencilIcon, FaTrash as TrashIcon } from 'react-icons/fa';

import {
  showCurrencyConversionRateModalForAddEdit,
  showCurrencyConversionRateModalForRemove,
} from './store/actions';

const CurrencyConversionRatesAdminColumnRenderer = ({
  showCurrencyConversionRateModalForAddEdit,
  showCurrencyConversionRateModalForRemove,
  value,
  rowIndex,
}) => {
  const handleEditButtonClicked = useCallback(() => {
    showCurrencyConversionRateModalForAddEdit(value);
  }, [showCurrencyConversionRateModalForAddEdit, value]);

  const handleRemoveButtonClicked = useCallback(() => {
    showCurrencyConversionRateModalForRemove({ entity: value, rowIndex });
  }, [showCurrencyConversionRateModalForRemove, value, rowIndex]);

  return (
    <div>
      <button
        className="cell-icon-button"
        title="Edit Currency Conversion Rate"
        onClick={handleEditButtonClicked}
      >
        <PencilIcon size={16} className="cell-icon" />
      </button>
      <button
        className="cell-icon-button"
        title="Remove Currency Conversion Rate"
        onClick={handleRemoveButtonClicked}
      >
        <TrashIcon size={16} className="cell-icon" />
      </button>
    </div>
  );
};

CurrencyConversionRatesAdminColumnRenderer.propTypes = {
  value: PropTypes.shape({
    currencyConversionRate: CurrencyConversionRatePropTypes,
  }).isRequired,
  showCurrencyConversionRateModalForAddEdit: PropTypes.func.isRequired,
  showCurrencyConversionRateModalForRemove: PropTypes.func.isRequired,
  rowIndex: PropTypes.number.isRequired,
};

export default connect(
  null,
  {
    showCurrencyConversionRateModalForAddEdit,
    showCurrencyConversionRateModalForRemove,
  }
)(CurrencyConversionRatesAdminColumnRenderer);
